import { render, staticRenderFns } from "./ProductCP4.vue?vue&type=template&id=665e6379&scoped=true&"
import script from "./ProductCP4.vue?vue&type=script&lang=js&"
export * from "./ProductCP4.vue?vue&type=script&lang=js&"
import style0 from "./ProductCP4.vue?vue&type=style&index=0&id=665e6379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e6379",
  null
  
)

export default component.exports